module.exports = __webpack_public_path__ + "img/Stemness-GBM_10X_WTA.938d6c72.png";